import * as PIXI from 'pixi.js';

declare module 'pixi.js' {
    export interface Container {
        setDisplayParent(displayParent: PIXI.Container): void;
        removeDisplayParent(): void;
        displayParent?: PIXI.Container | null;
        displayChildren?: PIXI.Container[];
    }
}

PIXI.Container.prototype.renderWebGL = createRender(PIXI.Container.prototype.renderWebGL);
PIXI.Container.prototype.renderCanvas = createRender(PIXI.Container.prototype.renderCanvas);

// @ts-ignore
const processInteractive = PIXI.interaction.InteractionManager.prototype.processInteractive;

function createRender(originalRender: any) {
    return function render(renderer: any) {
        const object = this as PIXI.Container;

        if (
            object.displayParent &&
            // @ts-ignore
            !object.displayParent._destroyed
        ) return;

        originalRender.call(object, renderer);

        if (object.displayChildren) {
            for (let i = 0, l = object.displayChildren.length; i < l; i++) {
                // @ts-ignore
                if (object.displayChildren[i]._destroyed) continue;
                originalRender.call(object.displayChildren[i], renderer);
            }
        }
    };
}

function filterCb(child: PIXI.Container) {
    return child.parent === this;
}

// @ts-ignore
PIXI.interaction.InteractionManager.prototype.processInteractive = function (e, object, func, hitTest, interactive, isDisplayCall?: boolean) {
    if (
        !object ||
        !object.visible ||
        // @ts-ignore
        object._destroyed ||
        (object.displayParent && !isDisplayCall)
    ) {
        return false;
    }

    let result;

    if (object.displayChildren && object.displayChildren.length) {
        object.children.push(...object.displayChildren);
        result = processInteractive.call(this, e, object, func, hitTest, interactive, true);
        object.children = object.children.filter(filterCb, object);
    } else {
        result = processInteractive.call(this, e, object, func, hitTest, interactive);
    }

    return result;
};

PIXI.Container.prototype.setDisplayParent = function (displayParent: PIXI.Container): void {
    if (this.displayParent === displayParent) return;

    this.displayParent = displayParent;
    displayParent.displayChildren = displayParent.displayChildren || [];
    displayParent.displayChildren.push(this);
};

PIXI.Container.prototype.removeDisplayParent = function () {
    if (!this.displayParent) return;

    if (this.displayParent.displayChildren) {
        this.displayParent.displayChildren = this.displayParent.displayChildren
            .filter((child: PIXI.Container) => child !== this);
    }

    this.displayParent = null;
};
